import React from "react";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import { AddConfiguration } from "../pages/AddConfiguration/AddConfiguration";
import { ConfigurationList } from "../pages/ConfigurationList/ConfigurationList";
import { MacosSteps } from "pages/Docs/MacosSteps/MacosSteps";
import { MidjourneySteps } from "pages/Docs/midjourneySteps/MidjourneySteps";
import { OpenaiSteps } from "pages/Docs/openAiSteps/OpenAiSteps";
import { GettingStarted } from "pages/GettingStarted/GettingStarted";
import { Prompts } from "pages/Docs/Prompts/Prompts";
import { Wordpress } from "pages/Docs/wordpress/Wordpress";
import { Profile } from "pages/Profile/Profile";

export interface AppRoute {
  path: string;
  element: React.ReactNode;
}

export const appRoutes: AppRoute[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/configuration/list",
    element: <ConfigurationList />,
  },
  {
    path: "/configuration/add",
    element: <AddConfiguration />,
  },
  {
    path: "/configuration/edit/:id",
    element: <AddConfiguration />,
  },
  {
    path: "/documentation/macos-steps",
    element: <MacosSteps />,
  },
  {
    path: "/documentation/midjourney-steps",
    element: <MidjourneySteps />,
  },
  {
    path: "/documentation/openai-steps",
    element: <OpenaiSteps />,
  },
  {
    path: "/documentation/prompts",
    element: <Prompts />,
  },
  {
    path: "/documentation/wordpress-integration",
    element: <Wordpress />,
  },
  {
    path: "/getting-started",
    element: <GettingStarted />,
  },
  // {
  //   path: "/virtualassistant/list",
  //   element: <VirtualAssistantList />,
  // },
  // {
  //   path: "/virtualassistant/add",
  //   element: <AddVirtualAssistant />,
  // },
  // {
  //   path: "/virtualassistant/edit/:id",
  //   element: <AddVirtualAssistant />,
  // },
];
